import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import agent from '../../agent';
import {GridList, GridTile} from 'material-ui/GridList';
import ImageUpload from './ImageUpload';
import Dialog from 'material-ui/Dialog';


const mapDispatchToProps = dispatch => ({

});

const mapStateToProps = state => ({

});

class ArtistForm extends Component  {

  constructor(props) {
    super(props);

    this.state = {
      id: this.props.artist ? this.props.artist.id : agent.Artists.new(),
      name: this.props.artist ? this.props.artist.name : "",
      medium: this.props.artist ? this.props.artist.medium : "",
      mediums: this.props.artist ? this.props.artist.mediums : [],
      website: this.props.artist ? this.props.artist.website : "",
      instagram: this.props.artist ? this.props.artist.instagram : "https://instagram.com/",
      agency: this.props.artist ? this.props.artist.agency : "",
      location: this.props.artist ? this.props.artist.location : "",
      previous: this.props.artist ? this.props.artist.previous : "",
      images: this.props.artist && this.props.artist.images ? this.props.artist.images : [],
      dialogOpen: false,
    }
  }

  handleChange = (event, index, value) => this.setState({mediums:value});

  handleCancel = () => {
    this.props.cancelHandler();
  }

  handleDelete = () => {
    this.setState({dialogOpen: true});
  }

  handleConfirmDelete = () => {
    agent.Artists.delete(this.props.artist.id);
  }

  handleSave = event => {
    let artist = {
      name: this.state.name,
      medium: this.state.medium,
      mediums: this.state.mediums,
      website: this.state.website,
      instagram: this.state.instagram,
      agency: this.state.agency,
      location: this.state.location,
      previous: this.state.previous,
      images: this.state.images ? this.state.images : []
    }

    agent.Artists.update(this.state.id, artist)
      .then(() => {
        this.props.cancelHandler();
      });
  }

  handleValueChange = val => {
    this.setState(val);
  }

  handleDialogClose = () => {
    this.setState({dialogOpen: false});
  }

  render() {
    const divStyle = {
      display: this.state.display,
      marginBottom: '26px'
    };
    const dropdownStyle = {
      fontSize: '16px',
      marginLeft: '12px',
      lineHeight: '36px',
      height: '72px'
    };
    const menuStyle = {
      top: '23px'
    };
    const btnStyle = {
      margin: "12px 12px 12px 0",
      lineHeight: '30px',
    };
    const labelStyle = {
      fontSize: "18px",
      color: "rgba(0, 0, 0, 0.5)"
    };
    const gridList = {
      display: 'flex',
      flexWrap: 'nowrap',
      overflowX: 'auto',
      marginBottom: '10px'
    };
    const dialogActions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleDialogClose}
      />,
      <FlatButton
        label="Delete"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleConfirmDelete}
      />,
    ];
    const mediums = this.props.mediums;
    return (
      <div>
        <div className="artist-form" style={divStyle} id={"artist-form" + this.state.id}>
          <div style={{display:"flex"}}>
            <div>
              <TextField
                defaultValue={this.state.name}
                floatingLabelText="Name"
                floatingLabelStyle={labelStyle}
                onChange={e => this.handleValueChange({name: e.target.value})}
              />
              <TextField
                style={{marginLeft:'12px'}}
                defaultValue={this.state.location}
                floatingLabelText="Location"
                floatingLabelStyle={labelStyle}
                onChange={e => this.handleValueChange({location: e.target.value})}
              />
              <br />
              <TextField
                defaultValue={this.state.agency}
                floatingLabelText="Agency"
                floatingLabelStyle={labelStyle}
                onChange={e => this.handleValueChange({agency: e.target.value})}
              />
              <div style={{display:"inline-block", position: "relative", fontSize: "16px"}}>
                <label style={{fontSize: "18px", position: "absolute", lineHeight: "22px", left: "12px", top: "38px", transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms", zIndex: 1, transform: "scale(0.75) translate(0px, -28px)", transformOrigin: "left top 0px", pointerEvents: "none", userSelect: "none", color: "rgba(0, 0, 0, 0.5)"}}>Mediums</label>
                <SelectField style={dropdownStyle} menuStyle={menuStyle} multiple={true} value={this.state.mediums} onChange={this.handleChange}>
                  {Object.keys(mediums).map((medium,index) => {
                      return (
                        <MenuItem key={index} value={medium} primaryText={mediums[medium]} />
                      );
                    })}
                </SelectField>
              </div>
              <br />
              <TextField
                defaultValue={this.state.instagram}
                floatingLabelText="Instagram"
                style={{width: "75%"}}
                floatingLabelStyle={labelStyle}
                onChange={e => this.handleValueChange({instagram: e.target.value})}
              />
              <br />
              <TextField
                defaultValue={this.state.website}
                floatingLabelText="Website"
                style={{width: "75%"}}
                floatingLabelStyle={labelStyle}
                onChange={e => this.handleValueChange({website: e.target.value})}
              />
              <div>
                <RaisedButton label="Save" onClick={this.handleSave} primary={true} style={btnStyle} buttonStyle={{lineHeight: '30px'}} />
                <RaisedButton label="Cancel" onClick={this.handleCancel} style={btnStyle} buttonStyle={{lineHeight: '30px'}} />
                <FlatButton label="Delete" onClick={this.handleDelete} style={btnStyle} secondary={true} style={{lineHeight: '30px', top: '2px'}} />
                <Dialog
                  title={"Delete " + this.state.name}
                  actions={dialogActions}
                  modal={false}
                  open={this.state.dialogOpen}
                  onRequestClose={this.handleDialogClose}
                >
                  Are you sure you want to delete {this.state.name}?
                </Dialog>
              </div>
            </div>
            <div style={{marginLeft:"12px", fontSize:"16px"}}>
              Images
              <ImageUpload artistID={this.state.id} images={this.state.images} valChange={this.handleValueChange} />
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default connect(mapStateToProps,mapDispatchToProps)(ArtistForm);



// WEBPACK FOOTER //
// ./src/components/Admin/ArtistForm.js